/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'stats': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M36.1 221.9V13H10v221.9c0 7.2 5.9 13.1 13.1 13.1H245v-26.1H36.1z"/><path pid="1" d="M114.4 135.9l29.9 29.9c5.1 5.1 13.4 5.1 18.5 0l78.3-78.3L222.7 69l-69.1 69.1-29.9-29.9c-5.1-5.1-13.4-5.1-18.5 0L53 160.4l18.5 18.5 42.9-43z"/>'
  }
})
